import React from 'react';
import PropTypes from 'prop-types';
import { onKeyPress } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import history from '../../../../utils/history';
import CookieLib from '../../../../helpers/cookieLib';

export default function LinkFormatter(props) {
  const { data, createdBy, containerType, id, className = '' } = props;
  const createdBySameUser = CookieLib.getCookieByKey('cid') === createdBy;
  const onClickVendor = event => {
    event.stopPropagation();
    history.push({
      pathname: `/vendor/my${
        createdBySameUser ? 'vendor' : 'approval'
      }/detail/${id}`,
      state: {
        urlType: 'RESOURCE_DETAILS',
        containerType,
      },
    });
  };

  return (
    data && (
      <div
        tabIndex={0}
        onKeyDown={event => onKeyPress(event, () => onClickVendor(event))}
        onClick={onClickVendor}
        className={`primary-color vendor-hyperlink font-12 pointer ${className}`}
      >
        {data}
      </div>
    )
  );
}
LinkFormatter.propTypes = {
  data: PropTypes.string,
};
LinkFormatter.defaultProps = {
  data: '',
};
